import { render, staticRenderFns } from "./MessagePreview.vue?vue&type=template&id=dc480674&"
import script from "./MessagePreview.vue?vue&type=script&lang=js&"
export * from "./MessagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports